import { render, staticRenderFns } from "./EditMembership.vue?vue&type=template&id=9719d3b6"
import script from "./EditMembership.vue?vue&type=script&lang=ts"
export * from "./EditMembership.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports